export const getSquareApplicationErrorMessage = e =>
  `${e?.field ?? ''}: ${e?.message ?? ''}. ${e?.detail ?? ''}`;
